import { MainLayout } from "@/components/layout/MainLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PontoTab } from "@/components/ponto/PontoTab";
import { RegistrosTab } from "@/components/ponto/RegistrosTab";
import { RelatorioTab } from "@/components/ponto/RelatorioTab";
import { HorariosTab } from "@/components/ponto/HorariosTab";
import { EntradaManualTab } from "@/components/ponto/EntradaManualTab";
import { DocumentosTab } from "@/components/ponto/DocumentosTab";
import { ConfiguracaoTab } from "@/components/ponto/ConfiguracaoTab";
import { LiveStatusPanel } from "@/components/ponto/LiveStatusPanel";
import { FuncionariosTab } from "@/components/ponto/FuncionariosTab";
import { Clock, CalendarDays, FileText, Timer, LogIn, FolderOpen, Settings, Users } from "lucide-react";

export default function PontoPage() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl sm:text-4xl font-bold uppercase tracking-tight">Ponto Eletrônico</h1>
          <p className="text-muted-foreground mt-1">Controle de ponto com geolocalização dos funcionários</p>
        </div>
        <LiveStatusPanel />
        <Tabs defaultValue="ponto">
          <TabsList className="bg-secondary flex-wrap h-auto gap-1 p-1">
            <TabsTrigger value="ponto" className="gap-1.5" data-testid="tab-ponto">
              <Clock className="w-3.5 h-3.5" />Ponto
            </TabsTrigger>
            <TabsTrigger value="registros" className="gap-1.5" data-testid="tab-registros">
              <CalendarDays className="w-3.5 h-3.5" />Registros
            </TabsTrigger>
            <TabsTrigger value="relatorio" className="gap-1.5" data-testid="tab-relatorio">
              <FileText className="w-3.5 h-3.5" />Relatório
            </TabsTrigger>
            <TabsTrigger value="horarios" className="gap-1.5" data-testid="tab-horarios">
              <Timer className="w-3.5 h-3.5" />Horários
            </TabsTrigger>
            <TabsTrigger value="manual" className="gap-1.5" data-testid="tab-manual">
              <LogIn className="w-3.5 h-3.5" />Entrada Manual
            </TabsTrigger>
            <TabsTrigger value="documentos" className="gap-1.5" data-testid="tab-documentos">
              <FolderOpen className="w-3.5 h-3.5" />Documentos
            </TabsTrigger>
            <TabsTrigger value="funcionarios" className="gap-1.5" data-testid="tab-funcionarios">
              <Users className="w-3.5 h-3.5" />Funcionários
            </TabsTrigger>
            <TabsTrigger value="config" className="gap-1.5" data-testid="tab-config">
              <Settings className="w-3.5 h-3.5" />Configurações
            </TabsTrigger>
          </TabsList>
          <TabsContent value="ponto" className="mt-6"><PontoTab /></TabsContent>
          <TabsContent value="registros" className="mt-6"><RegistrosTab /></TabsContent>
          <TabsContent value="relatorio" className="mt-6"><RelatorioTab /></TabsContent>
          <TabsContent value="horarios" className="mt-6"><HorariosTab /></TabsContent>
          <TabsContent value="manual" className="mt-6"><EntradaManualTab /></TabsContent>
          <TabsContent value="documentos" className="mt-6"><DocumentosTab /></TabsContent>
          <TabsContent value="funcionarios" className="mt-6"><FuncionariosTab /></TabsContent>
          <TabsContent value="config" className="mt-6"><ConfiguracaoTab /></TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
